<button type="button" class="color-picker-trigger" cdkOverlayOrigin #origin="cdkOverlayOrigin" [class.open]="open()"
  [attr.aria-label]="label | translate" (click)="toggle()">
  <span class="swatch" [class.auto]="isAuto" [style.background]="isAuto ? null : value">
    @if (isAuto) {
      <mat-icon>brightness_auto</mat-icon>
    }
  </span>

  @if (label) {
    <span class="color-picker-label">{{ label | translate }}</span>
  }

  <mat-icon class="color-picker-arrow">arrow_drop_down</mat-icon>
</button>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="origin" [cdkConnectedOverlayOpen]="open()"
  [cdkConnectedOverlayPositions]="positions" [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop" (backdropClick)="open.set(false)" (detach)="open.set(false)">
  <div class="color-picker-panel">
    @if (allowAuto) {
      <button type="button" class="auto-option" [class.selected]="isAuto" (click)="choose('')">
        <span class="swatch auto"><mat-icon>brightness_auto</mat-icon></span>
        {{ 'color_picker.auto' | translate }}
      </button>
    }

    <div class="color-grid">
      @for (color of neutrals; track color) {
        <button type="button" class="color-option" [class.selected]="isSelected(color)" [style.background]="color"
          [title]="color" (click)="choose(color)"></button>
      }
    </div>

    <div class="color-grid">
      @for (color of hues; track color) {
        <button type="button" class="color-option" [class.selected]="isSelected(color)" [style.background]="color"
          [title]="color" (click)="choose(color)"></button>
      }
    </div>

    <!-- Any color: the system picker, or its hex code -->
    <div class="custom-row">
      <label class="custom-swatch" [title]="'color_picker.custom' | translate">
        <mat-icon>colorize</mat-icon>
        <input type="color" [value]="value || '#3B82F6'" (change)="choose($any($event.target).value.toUpperCase())" />
      </label>

      <input class="hex-input" type="text" maxlength="7" spellcheck="false" [placeholder]="'#3B82F6'"
        [value]="value || ''" (input)="typed($any($event.target).value)" />
    </div>
  </div>
</ng-template>
